import React from 'react';
import logo from '../assets/img/madebya-web-logo-320x320.png';
import logoX2 from '../assets/img/madebya-web-logo-320x320@2x.png';
import logoX3 from '../assets/img/madebya-web-logo-320x320@3x.png';
import { ApostropheBackground } from '../components/ApostropheBackground';
import Head from '../components/Head';
import { ContentBlock } from '../components/ContentBlock';
import { ContactForm } from '../forms/ContactForm';
import { Media } from '../components/Media';
import josiahProfile from '../assets/img/josiah-profile.jpg';
import nicoleProfile from '../assets/img/nicole-profile.jpg';
import { ExternalLink } from '../components/Links';
import MainLayout from '../layouts/MainLayout';
import { ClientLogos } from '../components/styled/ClientLogos';
import { clientsAndFriends } from '../data/clients-and-friends';

class IndexPage extends React.Component {
  state = {
    formVisible: false,
  };

  data;

  constructor(props) {
    super(props);
    this.data = props.data;
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState(state => ({
      formVisible: !state.formVisible,
    }));
  }

  render() {
    const { formVisible } = this.state;
    const srcSet = `${logo} 1x, ${logoX2} 2x, ${logoX3} 3x`;
    const {
      title,
      description,
      keywords,
      baseUrl,
      logoUrl,
      social,
    } = this.data.site.siteMetadata;

    return (
      <MainLayout useHashLinks={true}>
        <Head
          title={title}
          description={description}
          url={baseUrl}
          keywords={keywords}
          image={baseUrl + logoUrl}
          social={social}
        />
        <header
          className="flex flex-row justify-center items-center z-10 w-full bg-grey-lighter relative"
          style={{ padding: '9rem 0' }}
        >
          <img
            src={logo}
            srcSet={srcSet}
            alt="Apostrophe LLC - Graphic Design and Web Development"
            className="block w-32 sm:max-w-xs h-auto"
            width="320"
            height="320"
          />
          <ApostropheBackground />
        </header>
        <main>
          <ContentBlock
            title="Web Design + Art Direction"
            content="Apostrophe is a wife-and-husband graphic design & web development team located in Orange County, CA. We specialize in corporate branding, product design, web development, and app development."
            cta={{ text: "Let's Work Together", to: '#contact' }}
            flavor="white"
          />
          <ContentBlock
            title="Past clients + friends"
            cta={{ text: 'Get on this list', to: '#contact' }}
            flavor="dark"
            inset={false}
            id="work"
            maxWidth="3xl"
          >
            <div className="flex flex-row justify-around py-4 text-white">
              <ClientLogos logos={clientsAndFriends} />
            </div>
          </ContentBlock>
          {/*<ContentBlock*/}
          {/*title='Latest Posts'*/}
          {/*cta={{ text: 'Read more', to: '/blog' }}*/}
          {/*content='Some blog post blah blah'*/}
          {/*flavor='light'>*/}
          {/*</ContentBlock>*/}
          <ContentBlock
            title="Get to know team apostrophe"
            id="meet"
            // cta={[
            //   { text: 'Meet Josiah', to: '/team/josiah' },
            //   { text: 'Meet Nicole', to: '/team/nicole' },
            // ]}
          >
            <div className="max-w-lg">
              <Media
                content={
                  <React.Fragment>
                    <p>
                      Josiah is a well spoken, kind hearted Canadian who flew
                      south to the forever summer of Southern California for
                      love. Affectionately known as "Moose", Jo enjoys Olympic
                      weightlifting and a good pair of socks.
                    </p>
                  </React.Fragment>
                }
                item={
                  <img
                    src={josiahProfile}
                    className="w-24 rounded-full"
                    alt="Josiah Dahl"
                  />
                }
              />
              <Media
                content={
                  <React.Fragment>
                    <p>
                      Nicole, the more complex of the pair, is called "Colee" by
                      those who have met her more than twice. Nicole has been
                      "playing CEO" since she was a kid - setting up pretend
                      stores, designing products and selling them to anyone who
                      walked the halls of her childhood home.
                    </p>
                  </React.Fragment>
                }
                item={
                  <img
                    src={nicoleProfile}
                    className="w-24 rounded-full"
                    alt="Nicole Dahl"
                  />
                }
              />
              {/*<p>Collectively, Jo and Nicole have over 10 years of experience in design, development, product*/}
              {/*management,*/}
              {/*and creative direction</p>*/}
            </div>
          </ContentBlock>
          <ContentBlock title="Let's Work Together" flavor="dark" id="contact">
            <ContactForm />
          </ContentBlock>
        </main>
      </MainLayout>
    );
  }
}

export default IndexPage;

export const query = graphql`
  query IndexPageQuery {
    site {
      ...HeadMetadata
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js